import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MOCKUP_IMAGES } from '../data/content';
export function Hero() {
  return <header className="w-full bg-white px-4 pb-10 pt-8 sm:px-6 sm:pt-12" data-id="element-150" data-mp="9lv0eoeuobus">
      <div className="mx-auto max-w-3xl text-center" data-id="element-151" data-mp="4lywep65kkf8">
        <div className="flex items-center justify-center gap-2" data-id="element-152" data-mp="4njrcfwdq5dm">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy-900 font-serif text-lg font-bold text-white" data-id="element-153" data-mp="128frdnreylxt">
            K
          </span>
          <span className="font-sans text-[13px] font-bold uppercase tracking-[0.28em] text-navy-900" data-id="element-154" data-mp="sbb0jammi2ao">
            Dra. Karito
          </span>
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-6 font-serif text-[34px] font-bold leading-[1.08] tracking-tight text-navy-900 sm:text-5xl md:text-6xl" data-id="element-155" data-mp="nbonp2apio2e">
          Aprende exactamente qué paciente tratar, qué GLP-1 elegir y cómo
          titular <span className="italic text-brand" data-id="element-156" data-mp="3o7vk1k75dnxa">cada dosis</span>
        </motion.h1>

        <p className="mx-auto mt-5 max-w-xl text-[15.5px] leading-relaxed text-navy-700/85 sm:text-lg" data-id="element-157" data-mp="39al9qe68qo35">
          Domina cada decisión clínica —desde la selección del paciente hasta el
          seguimiento a largo plazo— con un algoritmo práctico que elimina la
          improvisación y te ayuda a prescribir GLP-1 con mayor seguridad en
          cada consulta.
        </p>

        <p className="mx-auto mt-4 max-w-xl text-[14px] leading-relaxed text-navy-700/70" data-id="element-158" data-mp="35akmq552t4kh">
          Más de <strong className="text-navy-900" data-id="element-159" data-mp="2qi0jz5lu8z3k">1.200 médicos</strong> ya
          confían en la Dra. Karito para actualizar su práctica clínica.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} src={MOCKUP_IMAGES.bundle} alt="Ruta Clínica GLP-1: 6 tomos clínicos y 5 bonos exclusivos en formato digital" className="mx-auto mt-8 w-full max-w-lg" loading="eager" data-id="element-160" data-mp="2hk87sabey7ke" />

        <div id="hero-cta" className="mx-auto mt-2 max-w-md" data-id="element-161" data-mp="ibgn6yda9rlt">
          <CTAButton label="Quiero la Ruta Clínica GLP-1" size="lg" pulse note="Descarga inmediata · Pago único · Acceso de por vida · Garantía de 7 días" data-id="element-162" data-mp="i9vp4yrrfqj7" />
        </div>

        <p className="mx-auto mt-6 flex max-w-md items-center justify-center gap-2 rounded-xl bg-navy-50 px-4 py-3 text-[13.5px] font-semibold leading-snug text-navy-800" data-id="element-163" data-mp="161b0fh1ili6l">
          <ShieldCheckIcon className="h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-164" data-mp="x14ohzlgsq9j" />
          Prescribe con la confianza de un especialista, aunque hoy todavía
          tengas dudas sobre los GLP-1.
        </p>
      </div>
    </header>;
}